import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { useIsMobile } from "@/hooks/useIsMobile";
import type { CreanceRow } from "@/lib/creance.api";
import type { CreanceViewMode } from "../creance.constants";

export function useCreancesPageState() {
  const [searchParams] = useSearchParams();
  const [onlyOverdue, setOnlyOverdue] = useState(searchParams.get("overdue") !== "false");
  const [search, setSearch] = useState("");
  const [viewMode, setViewMode] = useState<CreanceViewMode>("table");
  const [selectedCreance, setSelectedCreance] = useState<CreanceRow | null>(null);
  const isMobile = useIsMobile();

  useEffect(() => {
    if (isMobile) setViewMode("grid");
  }, [isMobile]);

  return {
    onlyOverdue,
    setOnlyOverdue,
    search,
    setSearch,
    viewMode,
    setViewMode,
    selectedCreance,
    setSelectedCreance,
  };
}
